export default __webpack_public_path__ + "static/media/coins-solid.8cd877bf.svg";